import { Button, Icon, TextField, Typography } from 'darrius';
import { Step } from '../../../components';
import { useState } from 'react';

export const ChangePassword = ({ onButtonClick, isButtonLoading }) => {
  const [email, setEmail] = useState('');
  const handleChange = (event) => {
    setEmail(event.target.value);
  };

  const getErrorMessage = () => {
    if (email.length) {
      return /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i.test(
        email
      )
        ? ''
        : 'Email válido requerido';
    }

    return '';
  };

  return (
    <Step.Root>
      <Step.Header>
        <Icon
          size={72}
          src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/celular.png`}
          alt="Ícone de celular"
        />
        <Typography.Subtitle size="l" className="spacing-stack-bottom-300">
          Para definir sua senha, digite seu e-mail cadastrado abaixo
        </Typography.Subtitle>
        <Typography.Text className="spacing-stack-bottom-300">
          Enviaremos um link para alterar a senha.
        </Typography.Text>
      </Step.Header>
      <Step.Body>
        <TextField
          className="spacing-stack-bottom-300"
          id="id"
          name="email"
          label="E-mail"
          placeholder="Digite seu e-mail"
          onChange={handleChange}
          onBlur={handleChange}
          value={email}
          errorMessage={getErrorMessage()}
          type="email"
        />
        <Step.Actions>
          <Button.Root
            type="button"
            fullWidth
            onClick={() => {
              onButtonClick(email);
            }}
            className="spacing-stack-bottom-100"
            isLoading={isButtonLoading}
          >
            Enviar
          </Button.Root>
          <Button.Link
            href="https://www3.directtalk.com.br/clientes/custom/directtalk/bot/"
            size="small"
            fullWidth
            variation="clear"
          >
            Preciso de Ajuda
          </Button.Link>
        </Step.Actions>
      </Step.Body>
    </Step.Root>
  );
};
